import { Component, Input, output } from '@angular/core';
//import { CommonHttpService , CommonService} from '../../../shared/services/common-http.service';
import { CommonHttpService, CommonService } from '../../../shared/services';
import { CommonMethods, Severity } from '../../../shared/helpers/common-methods';

@Component({
  selector: 'bi-recent-reports',
  templateUrl: './recent-reports.component.html',
  styleUrl: './recent-reports.component.scss',
  standalone:false
})
export class RecentReportsComponent {
  @Input() Items:any = [];
  updateFavourite = output<any>();
  constructor(private _commonHttpService: CommonHttpService, private _commonService: CommonService, private _commonMethods: CommonMethods) { 

  }

  /**
   * This method is used to toggele the favorite 
   * @param item it holds the current item
   */
  toggleFavourite(item: any) {
    console.log('recent report',item);
    let isFavourite = (item.isFavourite == 1) ? 0 : 1;
    item.isFavourite = isFavourite;
    
    this._commonHttpService.updateFavourite(item).subscribe((res: any) => {
      if (res.status === 1) {
        this.updateFavourite.emit(item);
        this._commonMethods.showToastMessage(res.message, '', Severity.success as Severity);
      }
    });
    /* //let userId = (item.userId) ? item.userId : 0;
    let data = { id: null, isFavourite: isFavourite, reportId: item.reportId, reportFrom: item.reportFrom };
    if (item.favouriteReports.length > 0) {
      data.id = item.favouriteReports[0].id;
    }
    this._commonHttpService.updateFavourite(data).subscribe((res: any) => {
      if (res.status === 1) {
        this.updateFavourite.emit(data);
        item.isFavourite = isFavourite;
        this._commonMethods.showToastMessage(res.message, '', Severity.success as Severity);
      }
    });*/
  }
}
